import { getCorrespondLabel } from '@/utils/global';

export const basename = '/web';
export const captchaConfig = {
    host: 'https://support.grtcloud.net',
    captchaId: 'd0752a0a-11ae-11eb-9273-e41f13671c48'
};

export const templateMap = {
    recommend: 'recommend',
    course: '101', //开放课
    exam: '102', //考试
    practise: '105', //作业
    researchresult: '106', //研修成果
    live: '103', //研讨会
    project: '104', //项目
    school: '108', //父母学堂
    audioBook: '107', //听书
    lecturer: 'lecturer', //讲师
    activity: '109', //活动
    competition: '201', //大赛
    talent: '304', //人才
    trainingPlan: '112', //培训计划
    onDemandCourse: '1', //点播课
    bbs: '113', //交流研讨
    lectureHall: '202' //展示互动
};

export const idTemplateMap = {
    101: getCorrespondLabel('101'),
    102: getCorrespondLabel('102'),
    103: getCorrespondLabel('103'),
    104: getCorrespondLabel('104'),
    105: getCorrespondLabel('105'),
    106: getCorrespondLabel('106'),
    107: getCorrespondLabel('107'),
    108: getCorrespondLabel('108'),
    109: getCorrespondLabel('109'),
    201: getCorrespondLabel('201')
};
export const competition_constants = {
    business_id: '1770786866887421954',
    template_id: '201'
};
export const fieldTypeMap = {
    // 1-文本 2-下拉 3-数值 4-级联 5-日期 6 -上传 7-前端自定义类型 org_id  8-附件
    TEXT: 1,
    SELECTED: 2,
    NUMBER: 3,
    CASCADE: 4,
    DATE: 5,
    UPLOAD: 6,
    SELECTEDTREE: 7,
    FILE: 8
};
export const ProjectActivityStatus = {
    // 1闯关模式 2未开始 3未完成 4已完成 5不计考核
    BreakLevel: 1,
    NoStart: 2,
    Undone: 3,
    Complete: 4,
    WithoutAssess: 5
};
export const BusinessStatus = {
    //ongoing_status 0 进行中 1 未开始 2 已结束
    InProgress:0,
    NoStart:1,
    Ended:2
};
export const BbsEditFlag = {
    // 编辑标识 0禁止编辑 1可以编辑
    DisabledEdit:0,
    canEdit:1
};

export const getAgentBaseUrl = (id) => {
    return `/agent/web/o/${id}/chat`;
};

export const markClickedConfigStorage = 'markClickedConfig';
export const needlessLoginUrl = ['/web/businessPublic-detail', '/web/businessPublic-learCard', '/web/business-detail'];
